import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alert bg-warning-soft" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle text-warning" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-barcode" }),
  /*#__PURE__*/_createTextVNode(" Pagamento via boleto ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, " Atenção, sessões pagas via boleto não podem ser canceladas. ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}